import { CustomDatePicker } from "../../../../../components/CustomDatePicker";
import { CustomSelect } from "../../../../../components/CustomSelect";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {BasketIcon, TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import SelectionMealsApp from "../../Functionality/SelectionMealsApp";
import MealItemCards from "../../SubComponents/MealItemCards";
import React from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import DivContainerBody from "../../../../../components/DivContainerBody";
import BannerInfo from './BannerInfo';
import SelectionMealsMainApp from "../../Functionality/SelectionMealsMainApp";

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 */

const SelectionMeals = () => {
    const {
        meal,
        foodieSetting,
        mealtimes,
        handleChange,
        contractorId,
        supplierId,
        servingDate,
        mealTimeId,
        handleClearBasket,
        goToBasket,
        goBack
    } = SelectionMealsMainApp();

    const {
        t,
        cafeteriasOptions,
        emptyFields,
        dishes,
        codeMessage,
        permission,
        DEV,
        showBanner,
        setShowBanner,
        handleSelection
    } = SelectionMealsApp();

    return (
        <>
            <HeadTittle
                name='foodie_dining'
                onBack={goBack}
            >
                {(DEV || supplierId || contractorId || servingDate || permission.includes(permissionObj?.WEB_FOODIE_MENU_SELECTION_CREATE)) && (
                    <>
                        <div className='position-relative'>
                            <>
                                <ButtonAction
                                    id="btn_sm_basket"
                                    name="basket"
                                    className="btn-icon-add"
                                    Icon={BasketIcon}
                                    onClick={() => goToBasket()}
                                />
                                { meal.menuMealTimeIds.length !== 0 &&
                                    <div className="position-absolute indicator-meals">
                                        {meal.menuMealTimeIds.length}
                                    </div>
                                }
                            </>

                        </div>
                        <ButtonAction
                            id='btn_sm_clean_basket'
                            name='empty_basket'
                            className='btn-icon-delete'
                            splitName={false}
                            Icon={TrashOutlineIcon}
                            onClick={() => handleClearBasket()}
                            disabled={!meal.menuMealTimeIds.length}
                        />
                    </>
                )}
            </HeadTittle>

            <DivContainerBody>
                <div className="row text-center pt-3 pb-1">
                    <div className="col-12 col-lg d-flex justify-content-center align-items-center">
                        <CustomSelect
                            disabled={false}
                            id={"slt_sm_diner"}
                            list={cafeteriasOptions || []}
                            name={"cafeteriaId"}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            trans={"select_cafeteria"}
                            value={meal.cafeteriaId || ''}
                            showNoSelectionOption={false}
                            keyName="id"
                        />
                    </div>

                    <div className="col-12 col-lg d-flex justify-content-center align-items-center">
                        <CustomSelect
                            id={"slt_scs_service_time"}
                            name="mealTime"
                            trans="service_time"
                            list={mealtimes || []}
                            showNoSelectionOption={false}
                            keyName={"id"}
                            value={meal.mealTime || ''}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            disabled={mealTimeId}
                        />
                    </div>
                    <div className="col-12 col-lg d-flex justify-content-center align-items-center" >
                        <div className="w-100">
                            <CustomDatePicker
                                id={"dtp_scs_date"}
                                name="date"
                                trans="cafeteria_serving_date"
                                value={meal.date}
                                minDate={new Date()}
                                onChange={(value) =>
                                    handleChange({ target: { name: "date", value } })
                                }
                                emptyFields={emptyFields}
                                required
                                views={['day']}     // Only day in the selector
                                openTo="day"
                                disabled={servingDate}
                                // Opens in day view
                            />
                        </div>
                    </div>
                </div>

                { (showBanner && dishes?.length > 0) &&
                    <BannerInfo
                        t={t}
                        className="col-12 mb-3"
                        foodieSetting={foodieSetting}
                        setShowBanner={setShowBanner}
                    />
                }
                <div className={"col-12 mb-5"}>
                    <MealItemCards handleSelection={handleSelection} dishes={dishes} codeMessage={codeMessage} />
                </div>
            </DivContainerBody>
        </>
    )
}

export default SelectionMeals
